const filter = () => {
    if ( $('.filter-module').length ) {
        let pageUrl = decodeURIComponent(window.location.href);

        $('.filter-module .article-category').each(function() {
            let category = $(this);
            let categorySlug = category.data('category-slug');

            // if a category filter has been set
            if (pageUrl.indexOf("category=") >= 0) {
                let pageUrlCategories = pageUrl.split('category=');
                let pageUrlCategoriesArray = pageUrlCategories[1].split(',');

                // if this category filter has been set
                if (pageUrlCategoriesArray.indexOf(categorySlug) >= 0) {

                    var urlParts = pageUrl.split('?');
                    
                    let categoryLink = urlParts[1]
                        .replace(categorySlug, '')
                        .replace('=,', '=')
                        .replace(',,', ',');

                    categoryLink = urlParts[0] + '?' + categoryLink;

                    // this might be breaking something.
                    // if (categoryLink.substr(categoryLink.length - 10) == '?category=') {
                    //     categoryLink = categoryLink.replace('?category=', '');
                    // }

                    category.attr("data-category-link", categoryLink);
                    category.addClass('active');
                } else {
                    let categoryLink = pageUrl + ',' + categorySlug;

                    category.attr("data-category-link", categoryLink);
                }
            } else {
                let categoryLink = pageUrl + '?category=' + categorySlug;

                category.attr("data-category-link", categoryLink);
            }
        });

        $('.filter-module .article-category').on('click', function() {
            window.location.href = $(this).data('category-link');
        });
    }
};

export default filter;